import React from 'react'
import { useShoppingCart } from "../../../context/CartContext.tsx/ShoppingCartContext";

interface TrialProductProp {
    boxes?: number | any;
    item_image?: string;
    variant_title?: string;
    price?: string | any;
    temp_cart_id?: number | any;
    cart_id: number | any;
    power_type?: string;
    compare_at_price?: string | any;
}

const TrialColorPlano = (props: TrialProductProp) => {
  return (
    <div>
        <>
      {/* <div className="productImage">
                <img src={props.item_image} alt="" />
            </div> */}
      {/* <p>{props.variant_title}</p> */}
      <div className="colorPrice quantityPrice ">
        <div className="eyeSpecs">
          <span className="eyeHeading quantity_heading">Quantity</span>
          <span className="quantityCountTrial">          
            {parseInt(props.boxes)}
          </span>
        </div>
        <div className="itemPrice">
          {/* <span className="itemPriceCompare">Rs. 300 </span> */}
          <span className="itemPriceCompare">
            Rs. {props.compare_at_price * parseInt(props.boxes)}{" "}
          </span>
          <span className="itemPriceSelling">
            Rs. {parseInt(props.price) * parseInt(props.boxes)}
          </span>
        </div>
      </div>
    </>
    </div>
  )
}

export default TrialColorPlano